import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Header from "../common/Header/Header";
import Navbar from "../common/Navbar/Navbar";
import Home from "../pages/Home/Home";
import Aboutus from "../pages/AboutUs/AboutUs";
import Division from "../pages/Division/Division";
import Gallery from "../pages/Gallery/Gallery";
import Blog from "../pages/Blog/Blog";
import Career from "../pages/Career/Career";
import ContactUs from "../pages/ContactUs/ContactUs";
import ApplyNow from "../pages/ApplyNow/ApplyNow";
import Footer from "../pages/Footer/Footer";
import WhoWeAre from "../pages/Home/WhoWeAre/WhoWeAre";
import OurSegment from "../pages/Home/OurSegment/OurSegment";
import Pdf from "../pages/PDF/Pdf";
import Neuro from "../pages/Division/Neuro";
import URO from "../pages/Division/URO";
import Gynec from "../pages/Division/Gynec";
import Ortho from "../pages/Division/Ortho";
import Diahop from "../pages/Division/Diahop";
import Division1 from "../pages/Division/Division1"
import GallarySlider from "../pages/Gallery/GallarySlider";
import PrivacyPolicy from "../pages/Footer/PrivacyPolicy";
import { setting, header } from "../config/services";
import CustomPage from "../components/CustomPage/CustomPage";

const Routers = () => {
  const [settingAPIData, setSettingAPIData] = useState([]);

  const handleSetting = async () => {
    try {
      const resp = await setting();
      if (resp.data.code === 200 || resp.data.code === 201) {
        setSettingAPIData(resp.data.responseBody);
      }
    } catch (error) {
      console.log("handlesubmit", error);
    }
  };
  useEffect(() => {
    handleSetting();
  }, []);

  const [headerAPIData, setHeaderAPIData] = useState(() => {
    // Retrieve data from sessionStorage on initial load
    const savedData = sessionStorage.getItem("headerData");
    return savedData ? JSON.parse(savedData) : null;
  });

  useEffect(() => {
    if (!headerAPIData) {
      // If no data in sessionStorage, call the API
      fetchHeaderAPI();
    }
  }, [headerAPIData]);

  const fetchHeaderAPI = async () => {
    try {
      const resp = await header();
      if (resp.data.code === 200 || resp.data.code === 201) {
        const apiData = resp.data.responseBody;
        setHeaderAPIData(apiData);
        sessionStorage.setItem("headerData", JSON.stringify(apiData)); // Save data in sessionStorage
      }
    } catch (error) {
      console.error("Error fetching header API:", error);
    }
  };

  return (
    <>
      <Router>
        <Header headerAPIData={headerAPIData}/>
        <Navbar headerAPIData={headerAPIData} />
        <Routes>
          <Route path="/" element={<Home settingAPIData={settingAPIData} headerAPIData={headerAPIData} />} />
          <Route path="/aboutus" element={<Aboutus settingAPIData={settingAPIData} headerAPIData={headerAPIData} />} />
          {/* <Route path="/division" element={<Division />} /> */}
          <Route path="/gallery" element={<Gallery settingAPIData={settingAPIData} headerAPIData={headerAPIData} />} />
          <Route path="/blog" element={<Blog settingAPIData={settingAPIData} headerAPIData={headerAPIData} />} />
          <Route path="/career" element={<Career settingAPIData={settingAPIData} headerAPIData={headerAPIData} />} />
          <Route path="/contactus" element={<ContactUs settingAPIData={settingAPIData} headerAPIData={headerAPIData}/>} />
          <Route path="/applyNow/:careerSlug" element={<ApplyNow />} />
          <Route path="/whoWeAre" element={<WhoWeAre />} />
          <Route path="/ourSegment" element={<OurSegment />} />
          <Route path="/blog/:blogSlug" element={<Pdf />} />
          <Route path="/division/:categorySlug" element={<Neuro  headerAPIData={headerAPIData}/>} />
          {/* <Route path="/URO" element={<URO />} />
          <Route path="/Gynec" element={<Gynec />} />
          <Route path="/Ortho" element={<Ortho />} />
          <Route path="/Diahop" element={<Diahop />} /> */}
          <Route path="/division/:categorySlug/:productSlug" element={<Division1 />} />
          <Route path="/division/:categorySlug/:productSlug/pdf/:id/" element={<Pdf />} />
          <Route path="/gallery/:gallerySlug" element={<GallarySlider settingAPIData={settingAPIData} headerAPIData={headerAPIData} />} />
          {/* <Route path="/privacypolicy" element={<PrivacyPolicy headerAPIData={headerAPIData} />} /> */}
          <Route path="/:page" element={<CustomPage/>} />
        </Routes>
        <Footer headerAPIData={headerAPIData} />
      </Router>
    </>
  );
};

export default Routers;
